if (!customElements.get('brand-resource-library')) {

  class BrandResourceLibrary extends HTMLElement {

    connectedCallback() {

      this.tabs =
        this.querySelector('[data-brand-tabs]');

      this.cards =
        Array.from(
          this.querySelectorAll('[data-resource-card]')
        );

      this.resourcePanel =
        this.querySelector('[data-resource-panel]');

      this.techPanel =
        this.querySelector('[data-tech-panel]');

      this.techResults =
        this.querySelector('[data-tech-results]');

      this.panelTitle =
        this.querySelector('[data-panel-title]');


      this.resourceSearchInput =
        this.querySelector('[data-resource-search]');

      this.resourceSearchStatus =
        this.querySelector('[data-resource-search-status]');


      this.techSearchInput =
        this.querySelector('[data-tech-search]');

      this.techSearchStatus =
        this.querySelector('[data-tech-search-status]');


      this.emptyState =
        this.querySelector('[data-resource-empty]');


      this.vendor =
        (this.dataset.vendor || '').trim();

      this.searchUrl =
        this.dataset.searchUrl || '/search';


      this.techKey =
        '__technical__';

      this.activeGroup =
        null;

      this.techLoaded =
        false;

      this.searchTimer =
        null;

      this.abortController =
        null;

      this.searchCache =
        new Map();


      this.modal =
        this.querySelector('[data-resource-modal]');

      this.modalBody =
        this.querySelector('[data-resource-modal-body]');

      this.modalTitle =
        this.querySelector('[data-resource-modal-title]');


      if (!this.tabs) {
        return;
      }


      this.dedupeCards();
      this.buildTabs();
      this.bindEvents();

    }



    normalizeGroup(value) {

      return (value || '')
        .trim()
        .replace(/\s+/g, ' ')
        .toLocaleLowerCase('de-DE');

    }



    dedupeCards() {

      const seen =
        new Set();


      this.cards.forEach((card) => {

        const id =
          card.dataset.resourceId;


        if (id && seen.has(id)) {

          card.remove();
          return;

        }


        if (id) {
          seen.add(id);
        }

      });


      this.cards =
        Array.from(
          this.querySelectorAll('[data-resource-card]')
        );

    }



    buildTabs() {

      const groups =
        new Map();


      this.cards.forEach((card) => {

        const label =
          card.dataset.resourceLabel ||
          'Weitere Ressourcen';


        const key =
          this.normalizeGroup(label);


        if (!groups.has(key)) {

          groups.set(key, {
            key,
            label
          });

        }

      });


      this.groups =
        groups;


      groups.forEach((group) => {

        this.tabs.appendChild(
          this.createTabButton(
            group.key,
            group.label
          )
        );

      });


      this.tabs.appendChild(
        this.createTabButton(
          this.techKey,
          'Technische Unterlagen'
        )
      );


      const firstGroup =
        groups.keys().next().value;


      if (firstGroup) {

        this.activateGroup(firstGroup);

      } else {

        this.activateGroup(this.techKey);

      }

    }



    createTabButton(key, label) {

      const button =
        document.createElement('button');


      button.type =
        'button';

      button.className =
        'brand-library__tab';

      button.dataset.groupKey =
        key;

      button.setAttribute(
        'role',
        'tab'
      );

      button.setAttribute(
        'aria-selected',
        'false'
      );

      button.textContent =
        label;


      return button;

    }



    bindEvents() {

      this.tabs.addEventListener(
        'click',
        (event) => {

          const button =
            event.target.closest('[data-group-key]');


          if (!button) {
            return;
          }


          this.activateGroup(
            button.dataset.groupKey
          );

        }
      );


      if (this.resourceSearchInput) {

        this.resourceSearchInput.addEventListener(
          'input',
          () => {

            this.filterResources();

          }
        );

      }


      if (this.techSearchInput) {

        this.techSearchInput.addEventListener(
          'input',
          () => {

            this.handleTechSearch();

          }
        );

      }


      this.addEventListener(
        'click',
        (event) => {

          const opener =
            event.target.closest(
              '[data-resource-open]'
            );


          if (!opener) {
            return;
          }


          event.preventDefault();

          this.openResource(opener);

        }
      );


      const closeButton =
        this.querySelector(
          '[data-resource-modal-close]'
        );


      if (closeButton) {

        closeButton.addEventListener(
          'click',
          () => {

            this.closeModal();

          }
        );

      }


      if (this.modal) {

        this.modal.addEventListener(
          'close',
          () => {

            this.clearModal();

          }
        );


        this.modal.addEventListener(
          'click',
          (event) => {

            if (event.target === this.modal) {

              this.closeModal();

            }

          }
        );

      }

    }



    activateGroup(key) {

      this.activeGroup =
        key;


      this.querySelectorAll(
        '[data-group-key]'
      ).forEach((button) => {

        const active =
          button.dataset.groupKey === key;


        button.classList.toggle(
          'is-active',
          active
        );


        button.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );

      });


      if (key === this.techKey) {

        if (this.resourcePanel) {
          this.resourcePanel.hidden = true;
        }

        if (this.techPanel) {
          this.techPanel.hidden = false;
        }


        if (this.panelTitle) {
          this.panelTitle.textContent =
            'Technische Unterlagen';
        }


        if (!this.techLoaded) {
          this.fetchTechResults('');
        }


        return;

      }


      if (this.resourcePanel) {
        this.resourcePanel.hidden = false;
      }

      if (this.techPanel) {
        this.techPanel.hidden = true;
      }


      const group =
        this.groups.get(key);


      if (this.panelTitle) {

        this.panelTitle.textContent =
          group
            ? group.label
            : 'Ressourcen';

      }


      if (this.resourceSearchInput) {
        this.resourceSearchInput.value = '';
      }


      if (this.resourceSearchStatus) {
        this.resourceSearchStatus.textContent = '';
      }


      this.filterResources();

    }



    filterResources() {

      const term =
        this.resourceSearchInput
          ? this.resourceSearchInput.value
              .trim()
              .toLocaleLowerCase('de-DE')
          : '';


      let visible =
        0;


      this.cards.forEach((card) => {

        const groupKey =
          this.normalizeGroup(
            card.dataset.resourceLabel
          );


        const searchText =
          (
            card.dataset.search || ''
          ).toLocaleLowerCase('de-DE');


        const matchesGroup =
          groupKey === this.activeGroup;


        const matchesSearch =
          !term ||
          searchText.includes(term);


        const show =
          matchesGroup &&
          matchesSearch;


        card.hidden =
          !show;


        if (show) {
          visible += 1;
        }

      });


      if (this.emptyState) {

        this.emptyState.hidden =
          visible !== 0;

      }


      if (this.resourceSearchStatus) {

        this.resourceSearchStatus.textContent =
          term && visible === 0
            ? 'Keine passenden Ressourcen gefunden.'
            : '';

      }

    }



    handleTechSearch() {

      window.clearTimeout(
        this.searchTimer
      );


      const term =
        this.techSearchInput
          ? this.techSearchInput.value.trim()
          : '';


      if (!term) {

        this.fetchTechResults('');
        return;

      }


      if (term.length < 2) {

        if (this.techSearchStatus) {

          this.techSearchStatus.textContent =
            'Mindestens 2 Zeichen eingeben.';

        }

        return;

      }


      if (this.techSearchStatus) {
        this.techSearchStatus.textContent = '';
      }


      this.searchTimer =
        window.setTimeout(
          () => {

            this.fetchTechResults(term);

          },
          350
        );

    }



    cleanSearchTerm(value) {

      return (value || '')
        .replace(/[\\":()]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();

    }



    escapeVendor(value) {

      return (value || '')
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"')
        .trim();

    }



    async fetchTechResults(term) {

      if (!this.techResults) {
        return;
      }


      if (!this.vendor) {

        this.techResults.innerHTML = `
          <div class="brand-library__empty">
            Für diese Collection konnte kein Hersteller ermittelt werden.
          </div>
        `;

        return;

      }


      const cleanTerm =
        this.cleanSearchTerm(term);


      const cacheKey =
        `${this.vendor}::${cleanTerm}`
          .toLocaleLowerCase('de-DE');


      if (this.searchCache.has(cacheKey)) {

        this.techResults.innerHTML =
          this.searchCache.get(cacheKey);


        if (this.techSearchStatus) {
          this.techSearchStatus.textContent = '';
        }


        this.techLoaded =
          true;

        return;

      }


      if (this.abortController) {

        this.abortController.abort();

      }


      this.abortController =
        new AbortController();


      if (this.techSearchStatus) {

        this.techSearchStatus.textContent =
          cleanTerm
            ? 'Suche …'
            : 'Unterlagen werden geladen …';

      }


      const vendor =
        this.escapeVendor(this.vendor);


      let query =
        `vendor:"${vendor}"`;


      if (cleanTerm) {

        query += ` ${cleanTerm}`;

      }


      const params =
        new URLSearchParams();


      params.set(
        'view',
        'brand-tech'
      );

      params.set(
        'type',
        'product'
      );

      params.set(
        'q',
        query
      );

      params.set(
        'options[prefix]',
        'last'
      );


      try {

        const response =
          await fetch(
            `${this.searchUrl}?${params.toString()}`,
            {
              signal:
                this.abortController.signal,

              headers: {
                Accept: 'text/html'
              }
            }
          );


        if (!response.ok) {

          throw new Error(
            `HTTP ${response.status}`
          );

        }


        const html =
          await response.text();


        const doc =
          new DOMParser()
            .parseFromString(
              html,
              'text/html'
            );


        const result =
          doc.querySelector(
            '[data-brand-tech-results]'
          );


        if (!result) {

          throw new Error(
            'Technische Ergebnisliste nicht gefunden.'
          );

        }


        const resultHtml =
          result.innerHTML;


        this.searchCache.set(
          cacheKey,
          resultHtml
        );


        this.techResults.innerHTML =
          resultHtml;


        if (this.techSearchStatus) {
          this.techSearchStatus.textContent = '';
        }


        this.techLoaded =
          true;

      }

      catch (error) {

        if (
          error.name === 'AbortError'
        ) {
          return;
        }


        console.error(
          'Brand technical search:',
          error
        );


        this.techResults.innerHTML = `
          <div class="brand-library__empty">
            Die technischen Unterlagen konnten nicht geladen werden.
          </div>
        `;


        if (this.techSearchStatus) {

          this.techSearchStatus.textContent =
            'Suche konnte nicht geladen werden.';

        }

      }

    }



    openResource(opener) {

      const type =
        opener.dataset.embedType;

      const url =
        opener.dataset.embedUrl;

      const title =
        opener.dataset.embedTitle || '';


      if (
        !url ||
        !this.modal ||
        !this.modalBody
      ) {
        return;
      }


      if (this.modalTitle) {
        this.modalTitle.textContent = title;
      }


      this.modalBody.innerHTML = '';


      if (type === 'youtube') {

        const videoId =
          this.getYouTubeId(url);


        if (!videoId) {

          window.open(
            url,
            '_blank',
            'noopener'
          );

          return;

        }


        const iframe =
          document.createElement(
            'iframe'
          );


        iframe.src =
          `https://www.youtube-nocookie.com/embed/${videoId}?rel=0`;


        iframe.title =
          title || 'YouTube Video';


        iframe.allow =
          'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';


        iframe.allowFullscreen =
          true;


        this.modalBody.appendChild(
          iframe
        );

      }


      if (type === 'pdf') {

        const iframe =
          document.createElement(
            'iframe'
          );


        iframe.src =
          url;

        iframe.title =
          title || 'Dokument';


        this.modalBody.appendChild(
          iframe
        );

      }


      if (
        typeof this.modal.showModal ===
        'function'
      ) {

        this.modal.showModal();

      } else {

        window.open(
          url,
          '_blank',
          'noopener'
        );

      }

    }



    getYouTubeId(value) {

      try {

        const url =
          new URL(value);


        if (
          url.hostname.includes('youtu.be')
        ) {

          return url.pathname
            .replace('/', '')
            .split('/')[0];

        }


        const watchId =
          url.searchParams.get('v');


        if (watchId) {
          return watchId;
        }


        const parts =
          url.pathname
            .split('/')
            .filter(Boolean);


        const embedIndex =
          parts.indexOf('embed');


        if (
          embedIndex !== -1 &&
          parts[embedIndex + 1]
        ) {

          return parts[
            embedIndex + 1
          ];

        }


        const shortsIndex =
          parts.indexOf('shorts');


        if (
          shortsIndex !== -1 &&
          parts[shortsIndex + 1]
        ) {

          return parts[
            shortsIndex + 1
          ];

        }

      }

      catch (error) {

        return null;

      }


      return null;

    }



    closeModal() {

      if (
        this.modal &&
        this.modal.open
      ) {

        this.modal.close();

      }

    }



    clearModal() {

      if (this.modalBody) {

        this.modalBody.innerHTML =
          '';

      }

    }

  }


  customElements.define(
    'brand-resource-library',
    BrandResourceLibrary
  );

}